// extracted by mini-css-extract-plugin
export default {"lawnArea":"AreaPanel_lawnArea__swoHj","areaValue":"AreaPanel_areaValue__7o+OP"};